import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

import {getReportDefaultFields} from '../../../reports/report-constants';
import type {ReportURLParams} from '../../../reports/report-types';

import {EditionRecipientListProvider} from '../../editions/recipient-list/edition-recipient-list-provider';
import {EntityListContainer} from '../../entity-lists/entity-list-container';

import {DripSequenceRecipientEngagementFilter} from './drip-sequence-recipient-engagement-filter';
import type {StatusFilter} from './drip-sequence-recipient-engagement-filter';

type Props = {
    dripSequenceId: string;
    unfilteredCount: number;
    filters: FilterObject[];
    search: string;
    selectedPage: number;
    selectedSortField: string;
    selectedFields: string[];
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onRemoveAllFilters: () => void;
    statusFilters: StatusFilter[];
    fieldFilterFunction: (arg1: string) => boolean;
};

export function DripSequenceRecipientListContainer(props: Props) {
    const {statusFilters, fieldFilterFunction, ...restProps} = props;

    return (
        <EditionRecipientListProvider>
            <EntityListContainer
                {...restProps}
                entityType='contacts'
                customEmptyStateComponent={
                    <EmptyStateSmall
                        title='This drip sequence hasn’t been sent to any recipients yet'
                        subtitle='As your drip goes out to new recipients, they’ll show up here'
                        icon={
                            <div style={{width: '75px'}}>
                                <Illustration
                                    src='magnifying-glass-empty-state'
                                    width='100%'
                                    height='100%'
                                />
                            </div>
                        }
                    />
                }
                graduatedFilters={
                    <div style={{minWidth: 'unset'}}>
                        <DripSequenceRecipientEngagementFilter
                            dripSequenceId={props.dripSequenceId}
                            filters={props.filters}
                            onParamChange={props.onParamChange}
                            urlParams={props.urlParams}
                            statusFilters={statusFilters}
                        />
                    </div>
                }
                fieldFilterFunction={fieldFilterFunction}
                unfilteredCount={props.unfilteredCount}
                unfilteredCountThreshold={0}
                scrollContainerSelector='#drip-sequence-recipient-list'
                defaultFields={getReportDefaultFields('dripEditionEngagement').split(',')}
                hasPeopleListFooter={true}
            />
        </EditionRecipientListProvider>
    );
}
